/* AUTO-GENERATED — do not edit.
   * Updated by scripts/buildSnapshot.ts
   */
export const STATIC_SNAPSHOT = {
    "about": {
        "description": "Our commitment to scientific integrity and transparency ensures that every solution we provide is backed by rigorous testing and proven results. We make the design and development of custom proteins easy so you can focus on what truly matters – creating exceptional products.",
        "name": "About",
        "page_sections": [
            {
                "about_header": {
                    "elements": [
                        {
                            "depth": 0.87,
                            "image": 3038,
                            "position": "0.7,0.05,0.3,1",
                            "position_mobile": "0,0.07,0.4,1",
                            "priority": true,
                            "scale": 0.4,
                            "type": "image"
                        },
                        {
                            "depth": 2.4,
                            "image": 3035,
                            "position": "0,0.1,0.6,1",
                            "position_mobile": "0.32,0.18,0.66,1",
                            "priority": true,
                            "scale": 0.4,
                            "text": "Our commitment to scientific integrity and transparency ensures that every solution we provide is backed by rigorous testing and proven results.\r\n",
                            "type": "image"
                        },
                        {
                            "depth": 0.3,
                            "image": 3040,
                            "position": "0.79,0.43,0.24,1.2",
                            "position_mobile": "0.09,0.46,0.42,1.2",
                            "priority": true,
                            "text": "Our commitment to scientific integrity and transparency ensures that every solution we provide is backed by rigorous testing and proven results.\r\n",
                            "type": "image"
                        },
                        {
                            "depth": 1.2,
                            "group_on_mobiles": "block-1",
                            "image": 799,
                            "position": "0,0.7,0.63,1",
                            "position_mobile": "0,0.93,0.96,1",
                            "text": "Our commitment to scientific integrity and transparency ensures that every solution we provide is backed by rigorous testing and proven results.\r\n<div class=\"spacer\"></div>\r\nWe de-risk the design and development of custom proteins and peptides, so you can focus on what truly matters – creating innovative, high-performing products.",
                            "type": "text"
                        },
                        {
                            "depth": 1.5,
                            "image": 3042,
                            "mobile_depth": 1.8,
                            "position": "0,1.154,0.3,0.8",
                            "position_mobile": "0,1.52,0.5,0.8",
                            "text": "Our commitment to scientific integrity and transparency ensures that every solution we provide is backed by rigorous testing and proven results.\r\n<br/>\r\n<br/>\r\nWe make the design and development of custom proteins easy so you can focus on what truly matters—creating exceptional products.\r\n",
                            "type": "image"
                        },
                        {
                            "depth": 2.4,
                            "group_on_mobiles": "block-2",
                            "image": 800,
                            "position": "0.4,1.19,0.54,1",
                            "position_mobile": "0,2.35,1,1",
                            "text": "At Xias Bio, our ethos is driven by a passion for innovation, collaboration and sustainability.",
                            "type": "text"
                        },
                        {
                            "depth": 0.8,
                            "group_on_mobiles": "block-2",
                            "position": "0,1.54,0.54,1",
                            "text": "We’re here to simplify the complex world of biotechnology; our unique modular LitePlatform™ is designed to streamline product development, reducing the investment usually associated with biotech.\r\n<div class=\"spacer\"></div>\r\nWe provide you with the freedom to be creative, push scientific boundaries, and differentiate your products in the market.",
                            "type": "text"
                        },
                        {
                            "depth": 1.6,
                            "image": 3044,
                            "mobile_depth": 3.4,
                            "position": "0.6,1.43,0.6,1",
                            "position_mobile": "0.44,1.71,0.75,1",
                            "text": "We’re here to simplify the complex world of biotechnology; our unique modular LitePlatform™ is designed to streamline product development.",
                            "type": "image"
                        },
                        {
                            "depth": 2,
                            "group_on_mobiles": "block-card",
                            "image": 3045,
                            "position": "0.1,2.05,0.34,0.84",
                            "position_mobile": "0,3.25,0.44,0.84",
                            "text": "We believe in empowering our clients by providing the tools and resources that minimize obstacles in product development, allowing you to explore new possibilities and redefine what’s possible in the industry.",
                            "title": "Empowerment",
                            "type": "card"
                        },
                        {
                            "depth": 1.1,
                            "group_on_mobiles": "block-card",
                            "image": 3046,
                            "position": "0.66,2.15,0.34,0.84",
                            "text": "Our LitePlatform™ is designed to eliminate the usual hurdles that complicate prototyping and commercialization. By simplifying complex biotechnological challenges, we help turn ideas into market-ready products faster, ensuring a smooth transition from concept to launch.",
                            "title": "Simplicity and efficiency",
                            "type": "card"
                        },
                        {
                            "depth": 1.6,
                            "group_on_mobiles": "block-card",
                            "image": 3047,
                            "position": "0.193,2.65,0.34,0.84",
                            "text": "At Xias Bio, we are your innovation partner. We work closely with our clients to develop tailored solutions, ensuring their products fulfil rigorous scientific efficacy and market compatibility. This collaborative approach ensures that our clients’ needs are met every step of the way.",
                            "title": "Collaboration",
                            "type": "card"
                        }
                    ],
                    "height_multiplier": 3.25,
                    "height_multiplier_mobile": 10.3,
                    "title": "Empowering innovation, simplicity, and collaboration"
                },
                "animation": "none",
                "flexible_height": true,
                "name": "About Header",
                "type": "about_header"
            },
            {
                "animation": "none",
                "flexible_height": true,
                "name": "Our Team",
                "team": {
                    "display": "in_page",
                    "title": "Our Team"
                },
                "type": "team"
            }
        ]
    },
    "api-events": {
        "events": [
            {
                "date": "20250928",
                "link": "https://www.forbes.com/connect/event/2025-forbes-under-30-summit/",
                "location": "Columbus, OH, USA",
                "name": "Forbes Summit 2025"
            },
            {
                "date": "20261226",
                "link": "https://ifscc2025.com/en/",
                "location": "Cannes, France",
                "name": "IFSCC Congress 2025"
            }
        ]
    },
    "api-news": {
        "news": [
            {
                "date": "20231222",
                "image": 760,
                "link": "https://techcrunch.com/2023/12/22/a-first-look-at-nine-new-indiebio-ny-companies-that-will-present-to-vcs-next-month/",
                "name": "A first look at nine new IndieBio NY companies that will present to VCs next month"
            }
        ]
    },
    "api-products": {
        "products": [
            {
                "categories": [
                    "haircare",
                    "skincare"
                ],
                "image": 1754,
                "image_1": 2283,
                "logo": "16,230,0.8,0.2,0,6,0.2,0.4,0.2,-30,10,20,0,1.1639,1.2662,6.8197,6946626,1,1,0.5206,1.6049,4.3983,10486526,0.8,1,-0.1228,2.6574,1.9769,16646528,1.4,1,-0.7664,3.5431,-0.4445,16724995,1.6,1,-1.5136,2.6574,-2.8658,16704796,1.4,1,-2.053,1.7716,-5.2872,304895,1.2,1,-2.3398,0.8858,-7.7083,16646528,0.8,1,-3.3395,0,-10.1297,304895,0.8,1",
                "name": "ResiLite™",
                "slug": "resilite",
                "summary": "Advanced protein innovation inspired by nature"
            },
            {
                "categories": [
                    "haircare"
                ],
                "image": 1755,
                "image_1": 2284,
                "logo": "20,480,1,0.5,0,6,0.3,0.6,0,-150,75,90,0,2.1614,1.7291,-0.3959,6946626,1.4,0,-1.8154,1.9884,-0.4711,6946626,1.4,1,0.9511,2.5938,0.653,10486526,1.6,1,-2.1613,3.1123,-0.9034,16646528,1.1,1,-1.2968,1.2477,-1.5866,16724995,1.2,1,0.7783,2.8531,0.0476,16704796,1.3,1,-0.4322,2.2479,-0.1252,304895,1,1,0.1729,2.5938,0.9986,304895,1,0",
                "name": "KeraLite™",
                "slug": "keralite",
                "summary": "Revolutionizing haircare with precision bioengineering"
            },
            {
                "categories": [
                    "skincare"
                ],
                "image": 1753,
                "image_1": 2424,
                "logo": "8,550,1,0,0,4,1.2,1.2,0.1,0,10,20,0,-3.2254,-1.4691,-1.9041,6946626,0.9,1,-2.1307,1.8416,3.5103,10486526,1.2,0.67,-0.9824,2.4966,1.5362,16646528,1.1,1,-0.4723,2.4467,-0.5197,16724995,1.3,1,-1.1091,-1.9631,-3.6897,16704796,1.4,1,0.398,2.4991,-3.6379,304895,1.2,0,0.8973,-0.7957,-2.4828,6946626,0.8,1,2.9891,-1.4691,-1.9041,304895,1.4,1",
                "name": "ElastiLite™",
                "slug": "elastilite",
                "summary": "Unlocking youthful skin with next-generation elastin innovation"
            },
            {
                "categories": [
                    "skincare"
                ],
                "image": 1752,
                "image_1": 2288,
                "logo": "8,800,1,0.35,-3,3,0.3,0.6,0.1,-8,0,0,0,-1.2385,3.3451,0.6928,6946626,1.1,1,-1.5146,-1.8834,-1.4511,10486526,1.1,1,1.3251,-0.3645,-1.498,16646528,1.1,1,3.1793,2.1282,-2.4171,16724995,1.1,1,-1.9528,2.6469,0.6746,10486526,1.1,1,1.6759,3.2101,0.2701,16704796,0.3,1,-0.0375,3.1198,1.1324,16724995,1.1,1,-1.202,2.5598,4.3412,16704796,0.9,1",
                "name": "SeaLite™",
                "slug": "sealite",
                "summary": "Revolutionizing sun protection with bio-inspired innovation"
            },
            {
                "categories": [
                    "skincare"
                ],
                "image": 1751,
                "image_1": 2289,
                "logo": "8,760,1,0.35,-3,3,0.4,0.3,0.2,-8,0,0,0,0.69,2.4901,2.2571,6946626,1.1,1,-3.1256,-2.1849,-1.0415,10486526,1.1,1,0.4528,-1.4043,-2.4238,304895,1.1,1,3.092,1.1289,-3.8821,16724995,1.1,1,-0.3768,1.9622,2.4979,10486526,1.1,1,3.3684,1.6087,0.0459,16704796,0.6,1,2.0783,0.4618,2.4552,16724995,1.1,1,-4.0993,-0.3546,-1.236,65280,0.7,1",
                "name": "CollaLite™",
                "slug": "collalite",
                "summary": "The next generation of collagen innovation"
            },
            {
                "categories": [
                    "skincare"
                ],
                "image": 1750,
                "image_1": 2290,
                "logo": "18,290,1,0.1,0,3,0.2,0.2,0.3,-25,0,0,0,-1.4858,-2.8495,-6.1566,6946626,0.6,1,2.3625,3.3433,-3.0865,10486526,1.2,1,3.8162,0.6102,-9.3276,16646528,1,1,-4.0432,-2.4367,-5.1429,16724995,1.3,1,0.3443,4.2298,-2.8019,16704796,1.1,1,0.0643,2.8796,0.5763,304895,1,1,-2.6572,3.3183,-4.2442,6946626,1,1,-2.3155,2.5555,-1.7929,6946626,1,0",
                "name": "LamiLite™",
                "slug": "lamilite",
                "summary": "The future of skin barrier repair"
            }
        ]
    },
    "api-setup": {
        "bespoke_animations": [
            {
                "animation_item": "15,640,1,0.1,7,2,0,0.3,-1,-16,0,0,0,-2.1562,0.2723,-3.2343,304895,1.4,1,2.3718,-2.1562,0.7514,16646528,1.4,1,1.0781,-0.3049,2.3718,16724995,1.6,1,0.8603,2.5282,3.3692,16704796,1.4,1,-0.3702,2.5374,2.5874,10486526,1.4,1,-0.4138,3.0187,1.3369,16704796,1,1,0,3.2343,-0.539,16646528,1,1,1.0781,2.1562,-3.2343,6946626,1,1",
                "name": "Animation Setup"
            },
            {
                "animation_item": "12,800,1,0.5,4,1,0.2,0.3,-0.1,-36,0,0,0,3.0411,1.5194,0.584,6946626,1,1,2.8939,0,-2.8939,10486526,1,1,0,2.8939,2.8939,16646528,1,1,-2.8939,0,2.8939,16724995,1,1,0,-2.8939,-2.8939,16704796,1,1,2.8939,0,2.8939,304895,1,1,0,2.8939,-2.8939,10486526,1,1,-2.8939,3.0623,-2.8939,6946626,1,1",
                "name": "Animation Setup"
            },
            {
                "animation_item": "48,200,1,0.3,11,-0.7,0.4,0,0.7,-300,130,210,0,-3.1379,-1.5211,-10.1473,6946626,1.1,1,0.8299,4.7688,-6.1802,10486526,1.4,1,3.007,-0.2744,-6.388,16646528,1.2,1,1.0814,4.1441,-7.6032,16724995,0.9,1,1.2879,5.1276,-9.097,16704796,1,1,1.2137,0.7016,-7.6766,304895,1.5,1,1.325,-5.0716,-8.9563,6946626,1,1,1.4117,0.475,-8.8549,16704796,1,1",
                "name": "Animation Setup"
            },
            {
                "animation_item": "44,218,1,0.3,15,4.2,0.4,0.05,0.2,-280,120,220,0,-1.5584,1.5211,-0.3754,304895,1.3,0,-1.6359,2.3009,-1.4098,304895,1.3,1,-3.2431,1.9284,-1.2775,16724995,1.6,1,-1.8741,2.7209,-1.0438,16646528,1.2,1,-1.6457,3.2162,-1.4337,10486526,0.9,1,-2.264,1.931,-0.6485,6946626,1.4,1,-2.0401,2.4458,-1.2734,16704796,1,1,-1.943,1.6628,-0.808,16704796,1,0",
                "name": "Animation Setup"
            },
            {
                "animation_item": "33,240,1,0.1,14,4.5,1,0.3,1.5,-310,95,180,0,4.1438,8.8164,-26.7232,16724995,1,1,1.3593,-7.235,-25.2425,16704796,2,1,6.6425,8.0056,-29.0882,304895,2.1,1,2.3996,-3.8766,-28.7779,6946626,1.9,1,-0.5777,-3.4965,-33.2615,10486526,1.5,1,6.9334,3.7826,-24.6905,16646528,2,1,2.8057,0.4594,-31.1107,304895,1.5,1,6.7205,6.3356,-28.2336,16646528,1.5,1",
                "name": "Animation Setup"
            },
            {
                "animation_item": "50,192,1,0.2,11,3.7,0.5,0,0.5,-270,80,150,0,1.1173,-5.3914,-6.0855,6946626,1,0,-1.177,-1.9552,-7.4291,6946626,1.3,1,1.631,-4.7624,-7.0725,16646528,1.5,1,-1.0178,-2.7643,-8.2076,10486526,1.3,1,-0.1748,-2.4345,-9.6926,16724995,0.9,1,0.1616,-4.3455,-6.0026,304895,1.5,1,0.2528,-3.3761,-8.4748,16704796,1,1,1.2581,-4.6888,-7.0734,16704796,1,0",
                "name": "Animation Setup"
            }
        ],
        "bespoke_details": "Our LitePlatform™ helps bring it to life. We’ll work with you to design truly groundbreaking proteins and peptides, that fit your product's unique needs.",
        "bespoke_solutions_button": {
            "title": "Start creating",
            "url": "/solutions/"
        },
        "bespoke_title": "Got an idea?",
        "components": [
            {
                "component": "team",
                "name": "Team Api",
                "slug": "api-team"
            },
            {
                "component": "products",
                "name": "Products Api",
                "slug": "api-products"
            },
            {
                "component": "news",
                "name": "News Api",
                "slug": "api-news"
            },
            {
                "component": "events",
                "name": "Events Api",
                "slug": "api-events"
            },
            {
                "component": "none",
                "name": "Blog Template",
                "slug": "blog-template"
            },
            {
                "component": "none",
                "name": "GDPR",
                "slug": "api-gdpr"
            }
        ],
        "connect_button": "Submit",
        "connect_categories_title": "Select Products",
        "connect_fail": "Ooops, something went wrong. Please try again later.",
        "connect_legal": "Xias Bio Ltd. needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our <a href=\"/privacy-policy\">Privacy Policy</a>.",
        "connect_success": "Thanks for submitting the form. A member of the Xias Bio team will contact you shortly.",
        "extra_categories": [
            {
                "name": "Bespoke LiteProteins™",
                "slug": "bespoke_liteproteins"
            },
            {
                "name": "Discovery Services",
                "slug": "peptide_discovery"
            }
        ],
        "footer_1": [
            {
                "blank": true,
                "name": "Linkedin",
                "slug": "https://www.linkedin.com/company/xias-bio/"
            }
        ],
        "footer_2": [
            {
                "name": "Privacy Policy",
                "slug": "privacy-policy"
            },
            {
                "name": "Terms & Conditions",
                "slug": "terms-conditions"
            }
        ],
        "gdpr_agree": "Accept cookies",
        "gdpr_decline": "Decline",
        "gdpr_text": "We use cookies to understand how you interact with our site and to help us improve your experience. Please read our <a href=\"/privacy-policy/\" aria-label=\"Privacy Policy\">Privacy Policy</a> ",
        "gdpr_tracking_code": "G-3SXPXP68VP",
        "inputs": [
            {
                "autocomplete": "given-name",
                "id": "first_name",
                "mandatory": true,
                "name": "First name",
                "order": 1
            },
            {
                "autocomplete": "family-name",
                "id": "last_name",
                "mandatory": true,
                "name": "Last name",
                "order": 1.1
            },
            {
                "autocomplete": "email",
                "compact_order": "2",
                "email_validation": true,
                "id": "email",
                "mandatory": true,
                "name": "Email",
                "order": 2
            },
            {
                "autocomplete": "phone",
                "compact_order": "2.1",
                "id": "phone",
                "name": "Phone number",
                "order": 3
            },
            {
                "autocomplete": "organization",
                "compact_order": "3",
                "id": "company",
                "name": "Company",
                "order": 4
            },
            {
                "autocomplete": "organization-title",
                "compact_order": "3.1",
                "id": "job_title",
                "name": "Job title",
                "order": 5
            },
            {
                "autocomplete": "details",
                "compact_order": "4",
                "id": "enquiry",
                "is_input_area": true,
                "mandatory": true,
                "name": "Nature of Enquiry",
                "order": 6
            }
        ],
        "legal": "© 2025 Xias Bio - All rights reserved",
        "main_menu_connect_button": {
            "title": "CONTACT",
            "url": "/contact/"
        },
        "main_menu_legal": "<a href=\"/privacy-policy/\" aria-label=\"Privacy Policy\">Privacy Policy</a> | <a href=\"/terms-conditions/\" aria-label=\"Terms & Conditions\">Terms & Conditions</a>  <br> \r\n\r\n© 2025 xiasbio.com",
        "main_menu_legal_mobile": "<a href=\"/privacy-policy/\" aria-label=\"Privacy Policy\">Privacy Policy</a> | <a href=\"/terms-conditions/\" aria-label=\"Terms & Conditions\">Terms & Conditions</a> <br/> \r\n\r\n© 2025 xiasbio.com\r\n",
        "main_menu_text": "<br/>\r\n<br/>\r\nCONTACT US\r\n<br/>\r\n<a href=\"mailto:info@xiasbio.com\" target=\"_blank\" rel=\"noopener\" aria-label=\"email\">info@xiasbio.com</a>\r\n<div></div>\r\n\r\nADDRESS\r\n<br/>\r\n<a href=\"https://www.google.com/maps?q=55.843083,-4.430389\" target=\"_blank\" rel=\"noopener\">\r\n  E116, Xias Bio Ltd, UWS Paisley Campus,<br/>\r\n  Lady Lane, Paisley, Scotland, PA1 2BE\r\n</a>\r\n<div></div>\r\n\r\nFOLLOW US\r\n<br/>\r\n<a href=\"https://www.linkedin.com/company/xias-bio/\" target=\"_blank\" rel=\"noopener\" aria-label=\"linkedin\">Linkedin</a>\r\n<br/>",
        "menu": [
            {
                "name": "Home"
            },
            {
                "name": "About",
                "slug": "about"
            },
            {
                "name": "Products",
                "slug": "products"
            },
            {
                "name": "Solutions",
                "slug": "solutions"
            },
            {
                "name": "Sectors",
                "slug": "sectors"
            },
            {
                "name": "Licensing",
                "slug": "licensing"
            },
            {
                "name": "News",
                "slug": "news"
            },
            {
                "name": "Contact",
                "slug": "contact"
            }
        ],
        "seo_filter": "gradient, acf_fc_layout, text, title, mobile, position, image, type, animation, button_text, display, logo_background_anim, stats_columns, flexible_background_position, pointer, scale_direction, slug, logo, categories"
    },
    "api-team": {
        "team": [
            {
                "categories": [
                    "founders"
                ],
                "image": 3018,
                "link": "https://www.linkedin.com/in/david-j-harvey/",
                "name": "David Harvey",
                "slug": "david_j_harvey",
                "title": "Co-Founder and CEO"
            },
            {
                "categories": [
                    "founders"
                ],
                "image": 3019,
                "link": "https://www.linkedin.com/in/faadilfawzy/",
                "name": "Faadil Fawzy",
                "slug": "faadil_fawzey",
                "title": "Co-Founder and CSO"
            },
            {
                "categories": [
                    "commercial_associate"
                ],
                "image": 3022,
                "link": "https://www.linkedin.com/in/eleanoreirvine/",
                "name": "Eleanore Irvine",
                "slug": "eleanore_irvine",
                "title": "Director of Business Development"
            },
            {
                "categories": [
                    "commercial_associate"
                ],
                "image": 3031,
                "link": "https://www.linkedin.com/in/jihan-anderson/",
                "name": "Jihan Anderson",
                "slug": "jihan_anderson",
                "title": "Business Development Manager"
            },
            {
                "categories": [
                    "investors"
                ],
                "image": 2937,
                "link": "https://sosv.com",
                "slug": "sosv"
            },
            {
                "categories": [
                    "investors"
                ],
                "image": 2503,
                "link": "https://happinesscapital.com/",
                "slug": "happiness_capital"
            },
            {
                "categories": [
                    "investors"
                ],
                "image": 2925,
                "link": "https://www.goodstartup.com/",
                "slug": "good_startup"
            },
            {
                "categories": [
                    "investors"
                ],
                "image": 2929,
                "link": "https://www.boxone.xyz/",
                "slug": "box_one"
            },
            {
                "categories": [
                    "investors"
                ],
                "image": 2932,
                "link": "https://cptcap.com/",
                "slug": "cpt_capital"
            }
        ]
    },
    "blog-template": {
        "page_sections": [
            {
                "animation": "none",
                "connect": {
                    "details": "Let us help you develop bespoke, scalable, and high-performance protein solutions. Contact us today to learn more about how we can collaborate and accelerate your next project.",
                    "display": "in_page",
                    "title": "Ready to create something extraordinary?",
                    "use_legal": true
                },
                "home_page_news": {
                    "button": {
                        "title": "View all news",
                        "url": "/news/"
                    },
                    "title": "Recent News"
                },
                "name": "Recent News",
                "type": "home_news"
            },
            {
                "animation": "none",
                "connect": {
                    "details": "Let us help you develop bespoke, scalable, and high-performance protein solutions. Contact us today to learn more about how we can collaborate and accelerate your next project.",
                    "display": "in_page",
                    "title": "Ready to create something extraordinary?",
                    "use_legal": true
                },
                "flexible_height": true,
                "name": "Contact",
                "type": "connect"
            }
        ]
    },
    "collalite": {
        "description": "The next generation of collagen innovation",
        "isProductPage": true,
        "name": "CollaLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Lasting resilience",
                    "details_image": 2394,
                    "details_mobile": "Lasting resilience",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "CollaLite™"
                        },
                        {
                            "text": "The next generation of"
                        },
                        {
                            "text": "collagen innovation"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "CollaLite™ by Xias Bio...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "CollaLite™ by Xias Bio is a groundbreaking advancement in collagen technology, designed to elevate skincare and rejuvenation solutions. Harnessing the power of functional collagen peptides sourced from diverse species and collagen types, CollaLite™ offers unmatched benefits for skin health, repair, and renewal.\r\n<br/><br/>\r\nBy integrating these curated human type | Collagen peptides into the LiteProtein™ platform, CollaLite™ delivers concentrated collagen activity with exceptional efficacy. This versatile ingredient is engineered for intensive skin repair, anti-aging benefits, and strengthening the skin’s natural barriers, making it the ideal choice for next-generation Cosmetics & Personal Care formulations.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2289,
                            "pointer": "none",
                            "position": "0.035,0.035,0.21,1"
                        },
                        {
                            "circle": true,
                            "image": 2391,
                            "pointer": "none",
                            "position": "0.33,0.58,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Why choose CollaLite...",
                "product_details": {
                    "details": "Characterized functionality",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0.05,0.25,0.3",
                            "text": "<b>Film & barrier formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.15,0.25,0.3",
                            "text": "<b>Reduction of fine lines & wrinkles</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0.07,0.9,0.25,0.2",
                            "text": "<b>Hydrogel formation</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Why choose CollaLite™?"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "In vitro Results...",
                "product_details": {
                    "details": "CollaLite™ has demonstrated transformative effects in in vitro studies",
                    "elements": [
                        {
                            "pointer": "left",
                            "position": "0.7,0.05,0.3,0.4",
                            "text": "<b>Skin damage repair</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.25,0.25,0.4",
                            "text": "<b>Epidermal barrier integrity</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.7,0.25,0.3",
                            "text": "<b>Anti-aging benefits: </b><br/>Stimulates skin renewal"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Proven Results in 3D Skin Models (Mattek-EFT-400)"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Skincare, reimagined",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Reimagine beauty",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Skincare, reimagined</div>\r\nCollaLite™ is a next-gen collagen solution that goes beyond the basics. Designed to repair, rejuvenate, and protect, it gives brands a powerful way to bring advanced, science-backed beauty to their customers. Ready to create skincare that truly stands out? CollaLite™ is your key.\r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2430,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Bespoke Solutions",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "footer"
            }
        ],
        "snap": true
    },
    "contact": {
        "description": "Contact Xias Bio today to make your product vision a reality.",
        "name": "Contact",
        "page_sections": [
            {
                "animation": "none",
                "connect": {
                    "details": "Contact Xias Bio today to discuss how we can help solve your most pressing challenges with scalable, sustainable solutions.",
                    "display": "title",
                    "title": "Contact",
                    "use_categories": true,
                    "use_legal": true
                },
                "flexible_height": true,
                "name": "Contact",
                "type": "connect"
            },
            {
                "animation": "none",
                "events_section": {
                    "title": "Upcoming events"
                },
                "flexible_height": true,
                "name": "Events",
                "type": "events"
            }
        ]
    },
    "elastilite": {
        "description": "Unlocking youthful skin with next-generation elastin innovation",
        "isProductPage": true,
        "name": "ElastiLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Resilient motion",
                    "details_image": 2397,
                    "details_mobile": "Resilient motion",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "ElastiLite™"
                        },
                        {
                            "text": "Unlocking youthful skin"
                        },
                        {
                            "text": "with next-generation"
                        },
                        {
                            "text": "elastin innovation"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "ElastiLite™ is a breakthrough",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "ElastiLite™ is a breakthrough in anti-aging science, engineered to replicate the vital properties of elastin – the protein responsible for maintaining youthful, firm, and elastic skin.\r\n<br/><br/> \r\nAs elastin levels decline with age, skin begins to lose its resilience and develop visible signs of aging. ElastiLite™ bridges this gap, offering a scientifically designed solution to combat the natural aging process.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2286,
                            "pointer": "none",
                            "position": "0.275,0,0.21,1"
                        },
                        {
                            "circle": true,
                            "image": 2422,
                            "pointer": "none",
                            "position": "0.08,0.58,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "What makes ElastiLite™ revolutionary?",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0,0,0.4,1",
                            "text": "Xias Bio has identified and integrated human elastin peptide sequences with anti-aging properties into its LiteProtein™ platform.\r\n<br/><br/>\r\nThe configuration of ElastiLite™ ensures a concentrated and functional elastin peptide profile, tailored for optimal performance in skincare formulations.\r\n<br/><br/>\r\nDesigned for normal to combination skin, ElastiLite™ provides mild regenerative effects, enhancing skin health without overwhelming natural processes.\r\n",
                            "vertical_centered": true
                        }
                    ],
                    "flexible_background_position": "0.23,0,0.8,0",
                    "title": "What makes ElastiLite™ revolutionary?"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Physiological Properties",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.3",
                            "text": "<b>Film and barrier formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0,0.25,0.3",
                            "text": "<b>Visible wrinkle reduction</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.3,0.25,0.4",
                            "text": "<b>Hydrogel formation</b>: <br/>Alcohol and temperature-triggered"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.3,0.25,0.3",
                            "text": "<b>Microbiome maintenance</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.8,0.25,0.2",
                            "text": "<b>Antioxidant action</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.8,0.25,0.2",
                            "text": "<b>Biodegradable</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Physiological properties of ElastiLite™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "In vitro Results",
                "product_details": {
                    "details": "ElastiLite™ demonstrates impressive performance in lab tests (Mattek-EFT-400)",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.25",
                            "text": "<b>Encourages skin renewal</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.3,0.25,0.4",
                            "text": "<b>Improves barrier and hydration</b>: via extracellular matrix functions"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.3,0.25,0.4",
                            "text": "<b>Supports immunity and repair</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.7,0.25,0.3",
                            "text": "<b>Sustains skin vitality</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "<i>In Vitro</i> results on 3D skin models"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Your partner in next-level skin health",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Reimagine skincare",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Your partner in next-level skin health</div>\r\nElastiLite™ isn’t just another ingredient – it’s a breakthrough for brands looking to lead in anti-aging skincare. Backed by science and built for performance, it brings together innovation, sustainability, and serious results to help you create truly transformative beauty products.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2424,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Bespoke Solutions",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "type": "footer"
            }
        ],
        "snap": true
    },
    "home": {
        "description": "Our breakthrough protein design platform transforms our clients’ visions into reality.",
        "name": "Home",
        "page_sections": [
            {
                "animation": "circles",
                "force_snap": true,
                "name": "Story Step 1",
                "story": {
                    "button": {
                        "title": "Accelerate innovation",
                        "url": "/products/"
                    },
                    "details": "2.7 million possible<br/>combinations",
                    "story_lines": [
                        {
                            "text": "Accelerate your custom protein"
                        },
                        {
                            "text": "and peptide innovations with the"
                        },
                        {
                            "text": "LitePlatform™ – our breakthrough"
                        },
                        {
                            "text": " design technology."
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "logo",
                "force_snap": true,
                "logo_points": "12,800,1,0.2,6,1,0.2,0.6,2.5,-36,0,0,0,2.9231,0,-2.9231,304895,0.4,0,2.9231,0,-2.9231,304895,0.4,1,0,2.9231,2.9231,16704796,0.4,1,-2.9231,0,2.9231,16724995,0.4,1,0,-2.9231,-2.9231,16646528,0.4,1,2.9231,0,2.9231,10486526,0.4,1,0,2.9231,-2.9231,6946626,0.4,1,-2.9231,0,-2.9231,6946626,0.4,0",
                "name": "Story Step 2",
                "story": {
                    "button": {
                        "title": "Bespoke solutions",
                        "url": "/solutions/"
                    },
                    "details": "Recombinant protein<br/>and peptide technologies",
                    "details_image": 2315,
                    "story_lines": [
                        {
                            "text": "Protein and peptide actives "
                        },
                        {
                            "text": "with tailored functionality,"
                        },
                        {
                            "text": "potency and properties to make "
                        },
                        {
                            "text": "your product vision a reality."
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "logo",
                "force_snap": true,
                "logo_points": "7,450,1,0.5,-3,4,0,0.8,0.9,0,0,0,0,1.1294,-1.4103,0.3087,6946626,1,1,-1.7991,1.7682,5.5065,10486526,1,1,-0.697,2.3965,3.6111,16646528,1,1,-0.2076,2.349,1.6375,16724995,1,1,0.156,-1.8845,-1.4058,16704796,1,1,3.8184,-0.2819,-2.5766,304895,1,1,2.4929,-2.6185,-5.7224,10486526,1,1,1.1294,-1.4103,0.3087,6946626,1,1",
                "name": "Story Step 3",
                "story": {
                    "button": {
                        "title": "Design yours now",
                        "url": "/contact/"
                    },
                    "details": "Naturally inspired<br/>combinations",
                    "details_image": 2317,
                    "story_lines": [
                        {
                            "text": "Ethical, animal-free solutions"
                        },
                        {
                            "text": "with cutting-edge biotech"
                        },
                        {
                            "text": "performance, to ensure you stay"
                        },
                        {
                            "text": "ahead of your competition."
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "logo",
                "force_snap": true,
                "logo_points": "7,450,1,0.5,-3,4,0,0.8,0.9,0,0,0,0,1.1294,-1.4103,0.3087,6946626,1,1,-1.7991,1.7682,5.5065,10486526,1,1,-0.697,2.3965,3.6111,16646528,1,1,-0.2076,2.349,1.6375,16724995,1,1,0.156,-1.8845,-1.4058,16704796,1,1,3.8184,-0.2819,-2.5766,304895,1,1,2.4929,-2.6185,-5.7224,10486526,1,1,1.1294,-1.4103,0.3087,6946626,1,1",
                "logo_rotation": "30,60,30",
                "name": "Story Step 4",
                "story": {
                    "button": {
                        "title": "Work with us",
                        "url": "/licensing/"
                    },
                    "story_lines": [
                        {
                            "text": "Flexible licensing"
                        },
                        {
                            "text": "options to accelerate"
                        },
                        {
                            "text": "your vision."
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "logo_points": "16,230,0.8,0.2,0,6,0.2,0.4,0.2,-30,10,20,0,1.1639,1.2662,6.8197,6946626,1,1,0.5206,1.6049,4.3983,10486526,0.8,1,-0.1228,2.6574,1.9769,16646528,1.4,1,-0.7664,3.5431,-0.4445,16724995,1.6,1,-1.5136,2.6574,-2.8658,16704796,1.4,1,-2.053,1.7716,-5.2872,304895,1.2,1,-2.3398,0.8858,-7.7083,16646528,0.8,1,-3.3395,0,-10.1297,304895,0.8,1",
                "name": "Products Slider",
                "products_section": {
                    "details": "LiteProteins™ are adaptable, multi-functional proteins, designed with your products in mind, differentiating them from the rest.",
                    "details_button": {
                        "target": "_blank",
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "story": {
                    "button": {
                        "title": "Let’s begin",
                        "url": "/licensing/"
                    },
                    "story_lines": [
                        {
                            "text": "Reduce risk with flexible"
                        },
                        {
                            "text": "licensing that works for you."
                        },
                        {
                            "text": "Let’s turn your beauty"
                        },
                        {
                            "text": "concepts into standout"
                        },
                        {
                            "text": "products – designed for high"
                        },
                        {
                            "text": "performance, consumer appeal,"
                        },
                        {
                            "text": "and faster time-to-market."
                        }
                    ]
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Explore technology",
                "products_section": {
                    "details": "LITEproteins™ are smart, multi-functional proteins designed to spark innovation and give your products a real edge – whatever your industry.",
                    "details_button": {
                        "target": "_blank",
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LITEproteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "force_snap": true,
                "home_page_sectors": {
                    "button": {
                        "title": "Partner now",
                        "url": "/sectors/"
                    },
                    "details_1": "Partner with Xias Bio to create smart,",
                    "details_2": "scalable innovations for any industry.",
                    "images": [
                        {
                            "depth": 2.5,
                            "image": 903,
                            "link": "/sectors/",
                            "position": "0,0.19,0.25,1",
                            "position_mobile": "0,0.5,0.36,1"
                        },
                        {
                            "depth": 0.5,
                            "image": 904,
                            "link": "/sectors/",
                            "position": "0.2,0.1,0.36,1",
                            "position_mobile": "0.11,0.19,0.51,1"
                        },
                        {
                            "depth": 1,
                            "image": 901,
                            "link": "/sectors/",
                            "position": "0.76,0.15,0.24,1.2",
                            "position_mobile": "0.59,0.36,0.37,1.2"
                        },
                        {
                            "depth": 1.8,
                            "image": 902,
                            "link": "/sectors/",
                            "position": "0.47,0.37,0.27,0.8",
                            "position_mobile": "0.45,0.7,0.37,0.8"
                        }
                    ],
                    "title": "Looking for sustainable solutions that grow with you?"
                },
                "name": "Sectors",
                "type": "home_sectors"
            },
            {
                "animation": "none",
                "force_snap": true,
                "home_page_pricing": {
                    "buttons": [
                        {
                            "button": {
                                "title": "Discovery services",
                                "url": "/licensing/#discovery-services"
                            }
                        },
                        {
                            "button": {
                                "title": "Custom design",
                                "url": "/licensing/#custom-design"
                            }
                        },
                        {
                            "button": {
                                "title": "LiteProteins™",
                                "url": "/licensing/#liteprotein-licensing"
                            }
                        },
                        {
                            "button": {
                                "title": "Commercial licensing",
                                "url": "/licensing/#commercial-production"
                            }
                        }
                    ],
                    "details": "Modular licensing and pricing at Xias Bio: Tailored solutions for every stage of your project.",
                    "title": "Work with us"
                },
                "home_page_sectors": {
                    "button": {
                        "title": "Partner Now",
                        "url": "/sectors/"
                    },
                    "details_1": "Partner with Xias Bio to create smart,",
                    "details_2": "scalable innovations for any industry.",
                    "images": [
                        {
                            "depth": 2.5,
                            "image": 903,
                            "link": "/sectors/",
                            "position": "0,0.19,0.25,1",
                            "position_mobile": "0,0.5,0.36,1"
                        },
                        {
                            "depth": 0.5,
                            "image": 904,
                            "link": "/sectors/",
                            "position": "0.2,0.1,0.36,1",
                            "position_mobile": "0.11,0.19,0.51,1"
                        },
                        {
                            "depth": 1,
                            "image": 901,
                            "link": "/sectors/",
                            "position": "0.76,0.15,0.24,1.2",
                            "position_mobile": "0.59,0.36,0.37,1.2"
                        },
                        {
                            "depth": 1.8,
                            "image": 902,
                            "link": "/sectors/",
                            "position": "0.47,0.37,0.27,0.8",
                            "position_mobile": "0.45,0.7,0.37,0.8"
                        }
                    ],
                    "title": "Looking for sustainable solutions that grow with you?"
                },
                "name": "Work with us",
                "type": "home_pricing"
            },
            {
                "animation": "none",
                "force_snap": true,
                "home_page_news": {
                    "button": {
                        "title": "View all news",
                        "url": "/news/"
                    },
                    "title": "News"
                },
                "home_page_pricing": {
                    "buttons": [
                        {
                            "button": {
                                "title": "Evaluation License",
                                "url": "/licensing/#evaluation"
                            }
                        },
                        {
                            "button": {
                                "title": "Development License",
                                "url": "/licensing/#development"
                            }
                        },
                        {
                            "button": {
                                "title": "Manufacturing License",
                                "url": "/licensing/#manufacturing"
                            }
                        }
                    ],
                    "details": "Modular pricing at Xias Bio: Tailored solutions for every stage of your project",
                    "title": "Licensing"
                },
                "home_page_sectors": {
                    "button": {
                        "title": "Learn more",
                        "url": "/sectors/"
                    },
                    "details_1": "Unlock sustainable, scalable solutions",
                    "details_2": "across multiple industries with Xias Bio",
                    "images": [
                        {
                            "depth": 2.5,
                            "image": 903,
                            "link": "/sectors/",
                            "position": "0,0.19,0.25,1",
                            "position_mobile": "0,0.5,0.36,1"
                        },
                        {
                            "depth": 0.5,
                            "image": 904,
                            "link": "/sectors/",
                            "position": "0.2,0.1,0.36,1",
                            "position_mobile": "0.11,0.19,0.51,1"
                        },
                        {
                            "depth": 1,
                            "image": 901,
                            "link": "/sectors/",
                            "position": "0.76,0.15,0.24,1.2",
                            "position_mobile": "0.59,0.36,0.37,1.2"
                        },
                        {
                            "depth": 1.8,
                            "image": 902,
                            "link": "/sectors/",
                            "position": "0.47,0.37,0.27,0.8",
                            "position_mobile": "0.45,0.7,0.37,0.8"
                        }
                    ],
                    "title": "Sectors"
                },
                "name": "News",
                "type": "home_news"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Contact Xias Bio today to make your product vision a reality.",
                    "display": "in_page"
                },
                "force_snap": true,
                "home_page_news": {
                    "button": {
                        "title": "View all news",
                        "url": "/news/"
                    },
                    "title": "News"
                },
                "name": "Footer",
                "type": "footer"
            }
        ],
        "snap": true
    },
    "keralite": {
        "description": "Revolutionising Haircare with Precision Bioengineering",
        "isProductPage": true,
        "name": "KeraLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Flexible strength",
                    "details_image": 2406,
                    "details_mobile": "Flexibile strength",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "KeraLite™"
                        },
                        {
                            "text": "Revolutionizing"
                        },
                        {
                            "text": "haircare with"
                        },
                        {
                            "text": "precision"
                        },
                        {
                            "text": "bioengineering"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "KeraLite™ is a cutting-edge innovation...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "KeraLite™ is a cutting-edge innovation inspired by keratin, the structural protein essential to the strength and resilience of skin, nails, and hair. Engineered by Xias Bio, KeraLite™ harnesses the unparalleled properties of keratin peptides, delivering next-level performance for haircare formulations.\r\n<br/>\r\n<br/>\r\n<br/>\r\n<b/>Unleashing the power of keratin peptides</b/>\r\n<br/><br/>\r\nXias Bio has identified functional keratin peptide sequences from a variety of natural sources, including human α1 keratin. These sequences are seamlessly integrated into the LiteProtein™ platform, creating a concentrated and highly functional protein solution for advanced haircare applications.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2407,
                            "pointer": "none",
                            "position": "0.035,0.53,0.21,1"
                        },
                        {
                            "circle": true,
                            "image": 2284,
                            "pointer": "none",
                            "position": "0.33,0.028,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Physiological Properties...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.3",
                            "text": "<b>Film and barrier formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0,0.25,0.3",
                            "text": "<b>Hair restoration</b>: <br/>Cementing and smoothening properties repair damaged hair"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.3,0.25,0.4",
                            "text": "<b>Water/oil resistance</b>: <br/>Ultimate resilience with KeraLite's™ advanced film properties"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.3,0.25,0.3",
                            "text": "<b>Disulfide bridging for resilient conditioning</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.8,0.25,0.2",
                            "text": "<b>Hydrogel formation</b>: <br/>Temperature-triggered"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.8,0.25,0.2",
                            "text": "<b>Biodegradable</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Physiological properties of KeraLite™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Proven Benefits...",
                "product_details": {
                    "details": "<i>In Vitro</i> testing on human dermal papilla cells",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.25",
                            "text": "<b>Promotes hair growth:</b> <br/>Enhances natural pathways for healthier, denser hair"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.3,0.25,0.4",
                            "text": "<b>Boosts follicular vitality: </b><br/>Upregulates key growth markers and improves nutrient delivery to hair roots"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Proven benefits for hair health"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Why KeraLite™?",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Unlock performance",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Why KeraLite™?</div>\r\nIt’s where nature meets next-gen science. KeraLite™ helps you create high-performing, flexible haircare formulas that stand out. With its multitasking power and bioengineered precision, it’s setting a new bar for protein innovation in beauty and personal care.\r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2386,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Bespoke solutions",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "footer"
            }
        ],
        "snap": true
    },
    "lamilite": {
        "description": "The Future of Skin Barrier Repair",
        "isProductPage": true,
        "name": "LamiLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Perfect restoration",
                    "details_image": 2409,
                    "details_mobile": "Perfect restoration",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "LamiLite™"
                        },
                        {
                            "text": "The future of"
                        },
                        {
                            "text": "skin barrier repair"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LamiLite™ by Xias Bio is a...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "LamiLite™ by Xias Bio is a revolutionary protein ingredient that leverages the power of Laminin peptides to support skin regeneration and repair. Laminin, a key component of the basement membrane in skin, plays a crucial role in maintaining the skin’s structural integrity and function. With LamiLite™, Xias Bio has integrated these functional peptides into the LiteProtein™ platform to create a bioactive protein that provides effective barrier repair while being gentle on sensitive skin.\r\n\r\n\r\nLamiLite’s™ unique formulation is perfect for individuals with skin prone to irritation or sensitivities. It delivers mild yet powerful benefits for improving skin health, restoring hydration, and supporting the skin’s natural protective functions.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2317,
                            "pointer": "none",
                            "position": "0.025,0.055,0.182,1"
                        },
                        {
                            "circle": true,
                            "image": 2411,
                            "pointer": "none",
                            "position": "0.33,0.58,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Why Choose LamiLite...",
                "product_details": {
                    "details": "Characterized functionality",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0.05,0.25,0.3",
                            "text": "<b>Film &amp; barrier formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.15,0.25,0.3",
                            "text": "<b>Antioxidant</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0.05,0.9,0.25,0.2",
                            "text": "<b>Hydrogel formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.66,0.25,0.3",
                            "text": "<b>Biodegradable</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Why choose LamiLite™?"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "In vitro Results...",
                "product_details": {
                    "details": "LamiLite™ demonstrates impressive performance in lab tests",
                    "elements": [
                        {
                            "pointer": "left",
                            "position": "0.7,0.05,0.3,0.4",
                            "text": "<b>Supports skin barrier function</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.26,0.25,0.3",
                            "text": "<b>Reduces skin inflammation</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "<i>In vitro</i> results on 3D skin models"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Gentle yet powerful skin repair...",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Learn more",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div>Gentle yet powerful skin repair</div>\r\nLamiLite™ is a breakthrough ingredient for skincare brands focused on creating products that repair and strengthen the skin barrier. It offers a mild, yet effective solution for individuals with sensitive or reactive skin, providing long-lasting hydration and inflammation reduction. Perfect for soothing and rejuvenating, LamiLite™ brings advanced technology to the forefront of clean, effective skincare innovation.",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2355,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Bespoke solutions",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "footer"
            }
        ],
        "snap": true
    },
    "licensing": {
        "description": "At Xias Bio, we’re committed to tailoring protein solutions that meet your unique needs. ",
        "name": "Work with us",
        "page_sections": [
            {
                "animation": "none",
                "flexible_height": true,
                "licensing_title": {
                    "details_1": "At Xias Bio, we’re committed to tailoring protein and peptide solutions that meet your unique needs. ",
                    "details_2": "Whether you’re testing, developing, or scaling production, our discovery services and licensing options offer the flexibility and support you need to bring innovative products to market.",
                    "image_1": 808,
                    "image_2": 809,
                    "title": "Work with us"
                },
                "name": "Licenses Title",
                "type": "licensing_title"
            },
            {
                "animation": "none",
                "licenses": [
                    {
                        "button": {
                            "title": "Get in touch",
                            "url": "/contact/"
                        },
                        "details": "Use Xias Bio’s expertise to find new peptide and protein actives with in silico sequence mining and bioinformatics.\r\n<br/>\r\n<br/>\r\nProve their efficacy using Xias Bio’s in vitro screening and performance assays.",
                        "slug": "discovery-services",
                        "sub_title": "The protein and peptide universe at your fingerprints.",
                        "title": "Discovery services"
                    },
                    {
                        "button": {
                            "title": "Discover custom solutions",
                            "url": "/solutions/"
                        },
                        "details": "Our custom development projects deliver:\r\n<ul>\r\n<li>New and unique proteins and peptides.</li>\r\n<li>Formulation-ready samples for testing. produced using bacterial or yeast fermentation.</li>\r\n<li>Full R&D support from Xias Bio to accelerate your new ingredient into a finished product.</li>\r\n</ul>\r\n",
                        "flip": true,
                        "image": 802,
                        "slug": "custom-design",
                        "sub_title": "Develop new exclusive proteins, peptides and peptide blends designed to fit your product and marketing needs – all produced by fermentation.",
                        "title": "Custom design"
                    },
                    {
                        "button": {
                            "title": "View our LiteProteins™",
                            "url": "/products"
                        },
                        "details": "You’ll receive comprehensive data on functionality, quality control, and safety, along with technical support to address any questions. Plus, we provide up to 200g of samples for testing and evaluation.\r\n<br/>\r\n<br/>\r\nOnce testing is complete, we’ll guide you through securing a non-exclusive or exclusive manufacturing license to scale production.",
                        "image": 795,
                        "slug": "liteprotein-licensing",
                        "sub_title": "Test and evaluate any of the ready-made LiteProteins™ over a 6–12-month term.",
                        "title": "LiteProtein™ licensing"
                    },
                    {
                        "button": {
                            "title": "Discover custom solutions",
                            "url": "/solutions/"
                        },
                        "details": "Once your LiteProtein™ has been evaluated and tested, you can secure a 10-year minimum manufacturing license. This includes:\r\n<ul>\r\n<li>Flexible options for exclusive or non-exclusive rights.</li>\r\n<li>Permission to subcontract manufacturing.</li>\r\n<li>A clear fee structure.</li>\r\n<li>Focus on bringing your product to market.</li>\r\n</ul>\r\n",
                        "flip": true,
                        "image": 859,
                        "slug": "commercial-production",
                        "sub_title": "Scale production with exclusive or non-exclusive licensing options.",
                        "title": "Commercial licensing for production"
                    }
                ],
                "name": "Licenses",
                "type": "licenses"
            },
            {
                "animation": "none",
                "connect": {
                    "details": "If you're looking for custom high performance for your products, let Xias Bio help you realize your vision with tailored sustainable solutions.",
                    "display": "in_page",
                    "title": "Ready to transform your industry with breakthrough protein technology?",
                    "use_categories": true,
                    "use_legal": true
                },
                "flexible_height": true,
                "name": "Connect",
                "type": "connect"
            }
        ]
    },
    "news": {
        "description": "News of XiasBio",
        "name": "News",
        "page_sections": [
            {
                "animation": "none",
                "home_page_news": {
                    "full_page": true,
                    "title": "News"
                },
                "name": "News",
                "type": "home_news"
            }
        ]
    },
    "privacy-policy": {
        "description": "Privacy Notice",
        "name": "Privacy Notice",
        "page_sections": [
            {
                "animation": "none",
                "flexible_height": true,
                "legals": {
                    "content": "<ol class=\"title\">\r\n  <li><b> Who we are</b></li>\r\n</ol>\r\n<p><span>We are Xias Bio Limited, a company incorporated and registered in Scotland under the Companies Acts (no. SC657022) and having its registered\r\n    office at E116, Xias Bio Ltd, UWS Paisley Campus, Lady Lane, Paisley, Scotland, PA1 2BE</span></p>\r\n\r\n<ol class=\"title\" start=\"2\">\r\n  <li><b> How to contact us</b></li>\r\n</ol>\r\n<p><span>If you have any questions about this privacy notice, including any requests to exercise your legal rights, please contact us using the details\r\n    set out below.</span></p>\r\n\r\n<ul>\r\n  <li aria-level=\"1\"><span>By post: E116, Xias Bio Ltd, UWS Paisley Campus, Lady Lane, Paisley, Scotland, PA1 2BE</span></li>\r\n  <li aria-level=\"1\"><span>By email:&nbsp;</span><a href=\"mailto:info@xiasbio.com\"><span>info@xiasbio.com</span></a></li>\r\n</ul>\r\n\r\n<p><span>You have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK supervisory authority for data\r\n    protection issues (</span><a href=\"http://www.ico.org.uk/\"><span>www.ico.org.uk</span></a><span>). We would, however,\r\n    appreciate the chance to deal with your concerns before you approach the ICO so please contact us in the first instance.</span></p>\r\n\r\n<ol class=\"title\" start=\"3\">\r\n  <li><b> Privacy Information</b></li>\r\n</ol>\r\n<p><span>We are committed to protecting your personal data and your privacy. This privacy notice aims to give you information on how we collect and\r\n    process your personal data through your use of our website&nbsp;</span><a href=\"https://www.xiasbio.com/\"><span>https://www.xiasbio.com/</span></a><span>&nbsp;or any other\r\n    website registered in our name (“Website”), including any\r\n    personal data that you may provide through our Website, where we have a contract in place with you (please note that separate terms and conditions may also be applicable here),\r\n    and through your other communications with us and where we receive your personal data from a third party.</span></p>\r\n<p><span>It is important that you read this privacy notice when we are collecting or processing personal data about you so that you are fully aware\r\n    of how and why we are using your personal data.</span></p>\r\n<p><span>It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes\r\n    during your relationship with us.</span></p>\r\n<p><span>This version of our privacy notice was last updated on 22</span><span>nd</span><span>\r\n    November 2023.</span></p>\r\n\r\n<ol class=\"title\" start=\"4\">\r\n  <li><b> To whom does this privacy notice apply?</b></li>\r\n</ol>\r\n<p><span>This privacy notice applies to:</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>all individuals who visit our Website;</span></li>\r\n  <li aria-level=\"1\"><span>all individuals who are or were our “individual customers” where you are a sole trader, partner in a\r\n      traditional or limited partnership or member of an unincorporated association;</span></li>\r\n  <li aria-level=\"1\"><span>all individuals who are current or former employees, workers, directors, officers, job applicants or\r\n      otherwise related personnel of our corporate customer (being a corporate entity such as a limited company or limited liability partnership) or individual customer\r\n      (“customer-related individuals”);</span></li>\r\n  <li aria-level=\"1\"><span>all individuals who are our “business contacts” where you or your organisation supply goods or\r\n      services to us, provide professional services, have expressed an interest in us or have any other business relationship with us (including where your organisation is a public\r\n      authority, an industry body or regulatory authority or similar); or</span></li>\r\n  <li aria-level=\"1\"><span>all individuals who are our “shareholders” and/or “investors”.</span></li>\r\n</ul>\r\n<p><span>This privacy notice does not apply to employees, workers or other staff of Xias Bio Limited.</span></p>\r\n\r\n<ol class=\"title\" start=\"5\">\r\n  <li><b> Information about our Website</b></li>\r\n</ol>\r\n<p><span>Our Website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow\r\n    third parties to collect or share data about you. We do not control these third-party websites and we are not responsible for their privacy statements. When you leave our\r\n    Website, we encourage you to read the privacy notice of every website you visit.</span></p>\r\n\r\n<ol class=\"title\" start=\"6\">\r\n  <li><b> Cookies</b></li>\r\n</ol>\r\n<p><span>Cookies are small text files that are placed on your computer by websites that you visit. They are widely used in order to make websites work, or\r\n    work more efficiently, as well as to provide information to the owners of the site.</span></p>\r\n<p><span>You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or\r\n    refuse cookies, please note that some parts of the Website may become inaccessible or not function properly.</span></p>\r\n\r\n<ol class=\"title\" start=\"7\">\r\n  <li><b> Children</b></li>\r\n</ol>\r\n<p><span>Our Website is not intended for children and we do not knowingly collect any personal data relating to children.</span></p>\r\n\r\n<ol class=\"title\" start=\"8\">\r\n  <li><b> About the personal data that we collect and process</b></li>\r\n</ol>\r\n<p><span>“Personal data”, or personal information, means any information about an individual from which that person can be identified. It does not include\r\n    data where the identity has been removed (“anonymous data”).</span></p>\r\n<p><span>As part of our business we may receive pseudonymised personal data generated from clinical studies to evaluate the effectiveness of our\r\n    products. Pseudonymisation of data means replacing any information which could be used to identify an individual with a pseudonym, or, in other words, a value which does not\r\n    allow us to Identify an individual directly. We will process any pseudonymised personal data we receive (or generate) in accordance with the UK GDPR, Data Protection Act 2018\r\n    and any other relevant data protection laws.</span></p>\r\n<p><span>The table set out in SCHEDULE 1 summarises the personal data we collect and process, how we use it (“our processing purposes”) and why we use it\r\n    (“the lawful bases of processing”).</span></p>\r\n<p><span>We may also collect, use and share “Aggregated Data” such as statistical or demographic data for any purpose. Aggregated Data may be derived from\r\n    your personal data but is not considered personal data in law as this data does not directly or indirectly reveal your identity. For example, we may aggregate data to calculate\r\n    the percentage of individuals accessing a specific feature of our Website. However, if we combine or connect Aggregated Data with your personal data so that it can directly or\r\n    indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy notice.</span></p>\r\n\r\n<ol class=\"title\" start=\"9\">\r\n  <li><b> How is your personal data obtained?</b></li>\r\n</ol>\r\n<p><span>We use different methods to collect personal data from and about you including through:&nbsp;</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>Direct interactions. You may give us your identity, contact, financial, transactional or similar\r\n      personal data when you correspond with us by post, phone, e-mail or otherwise, including when you complete a form on our Website or otherwise contact us via our\r\n      Website.</span></li>\r\n</ul>\r\n<ul>\r\n  <li aria-level=\"1\"><span>Direct interactions with business contacts, individual customers and customer-related individuals.\r\n      You may give us your identity, contact, financial, transactional and other business related personal data when you correspond with us, including when:</span></li>\r\n</ul>\r\n<ul>\r\n  <li aria-level=\"1\"><span>you or your organisation negotiate and/or enter into a contract with us; or</span></li>\r\n  <li aria-level=\"1\"><span>you or your organisation provide services or products to us or your or your organisation receives\r\n      services or products from us; or</span></li>\r\n  <li aria-level=\"1\"><span>you provide us with your business card.</span></li>\r\n</ul>\r\n<ul>\r\n  <li aria-level=\"1\"><span>Direct interactions with our investors and/or shareholders. You may give us your identity, contact\r\n      and other business related personal data in the process of investing in Xias Bio Limited or where you communicate with us as a shareholder in Xias Bio Limited.</span></li>\r\n  <li aria-level=\"1\"><span>Automated technologies or interactions. As you interact with our Website, we may automatically\r\n      collect technical data about your equipment, browsing actions and patterns. We collect this personal data by using cookies, and other similar technologies.</span></li>\r\n  <li aria-level=\"1\"><span>Third parties or publicly available sources. We may receive personal data about you from various\r\n      third parties and public sources as set out below:</span></li>\r\n</ul>\r\n<ul>\r\n  <li aria-level=\"1\"><span>where you are a business contact, your organisation or business may provide us with your identity and\r\n      contact data.</span></li>\r\n  <li aria-level=\"1\"><span>where you are a customer-related individual, your organisation or business may provide us with your\r\n      identity and contact data.</span></li>\r\n  <li aria-level=\"1\"><span>we may obtain identity and contact data from publicly available sources such as social media (such as\r\n      LinkedIn or Twitter), Companies House or other organisations’ websites.</span></li>\r\n  <li aria-level=\"1\"><span>we may obtain contact, financial and transaction data from providers of payment and credit card\r\n      services.</span></li>\r\n  <li aria-level=\"1\"><span>we may obtain technical data (relating to the use of our Website) from analytics providers or search\r\n      information providers.</span></li>\r\n  <li aria-level=\"1\"><span>where you are a member of an investment syndicate investing in Xias Bio Limited the syndicate may\r\n      provide your personal data to us as part of the transaction.</span><span><br></span><span>&nbsp;</span></li>\r\n</ul>\r\n<ol class=\"title\" start=\"10\">\r\n  <li><b> Failure to provide personal data</b></li>\r\n</ol>\r\n<p><span>Where we need to collect personal data by law or under the terms of a contract we have with you (or are trying to enter into with you) and you\r\n    fail to provide that data when requested, we may not be able to perform the contract. In this case, we may have to cancel a contract (but we will notify you if this is the case\r\n    at the time).</span></p>\r\n\r\n<ol class=\"title\" start=\"11\">\r\n  <li><b> Marketing</b></li>\r\n</ol>\r\n<p><span>If you represent another business, we may provide you with direct marketing communications where we feel that this may be relevant to your\r\n    business (provided that you have not opted out of such communications). When we use your personal data for such purposes, we do so on the basis that it is in our legitimate\r\n    interests to pursue direct marketing, provided that it constitutes fair processing of your personal data to do so.</span></p>\r\n<p><span>You can also opt-out or unsubscribe from all or some of these marketing communications at any time by contacting us at&nbsp;</span><a\r\n    href=\"mailto:info@xiasbio.com\"><span>info@xiasbio.com</span></a><span>.</span></p>\r\n<p><span>Where you opt out of receiving these marketing communications, this opt-out will not apply to personal data provided to us for any other\r\n    purpose.</span></p>\r\n\r\n<ol class=\"title\" start=\"12\">\r\n  <li><b> With whom do we share your personal data?</b></li>\r\n</ol>\r\n<p><span>There may be circumstances in which we may also need to share your personal data with certain third parties (strictly on a confidential, business\r\n    need-to-know basis). The third parties to which we may transfer your personal data include:</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>Your business or organisation, for the purpose of providing our services or products to your business\r\n      or organisation, or receiving products or services from your business or organisation.</span></li>\r\n  <li aria-level=\"1\"><span>Our investors and/or shareholders.</span></li>\r\n  <li aria-level=\"1\"><span>Service providers acting as processors who provide IT and system administration services.</span></li>\r\n  <li aria-level=\"1\"><span>Professional advisers including lawyers, bankers, accountants, auditors and insurers who provide\r\n      consultancy, banking, legal, insurance and accounting services.</span></li>\r\n  <li aria-level=\"1\"><span>Any relevant accreditation body or trade association.</span></li>\r\n  <li aria-level=\"1\"><span>Any relevant regulatory authority or law enforcement agency, including HM Revenue &amp; Customs,\r\n      courts or tribunals who require reporting of processing activities in certain circumstances.</span></li>\r\n  <li aria-level=\"1\"><span>Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets.\r\n      Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way\r\n      as set out in this privacy notice.</span></li>\r\n</ul>\r\n<p><span>We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our\r\n    third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with\r\n    our instructions.</span></p>\r\n<p><span>Any sharing of your personal data will only take place either where we are legally obliged to do so, where it is necessary for the performance of\r\n    a contract with you or where it is in our legitimate interests to do so, including as follows:&nbsp;</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>to maintain network and information security;</span></li>\r\n  <li aria-level=\"1\"><span>to provide services or products to our corporate customers;</span></li>\r\n  <li aria-level=\"1\"><span>to develop and improve our services or products in order to remain competitive;</span></li>\r\n  <li aria-level=\"1\"><span>to establish, protect and defend our legal rights;</span></li>\r\n  <li aria-level=\"1\"><span>to pursue our commercial objectives where this does not override your rights and freedoms as a data\r\n      subject.</span></li>\r\n</ul>\r\n<p><b>&nbsp;</b></p>\r\n<ol class=\"title\" start=\"13\">\r\n  <li><b> International transfers</b></li>\r\n</ol>\r\n<p><span>We generally do not transfer your personal data out of the UK. However, whenever we are required to transfer your personal data out of the UK\r\n    (for example where a third party supplier is located outside of the UK), we ensure a similar degree of protection is afforded to it by ensuring that appropriate safeguards are\r\n    implemented, including any of the following:&nbsp;</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>We will only transfer your personal data to countries that have been deemed to provide an adequate\r\n      level of protection for personal data by the UK government.</span></li>\r\n  <li aria-level=\"1\"><span>Where we use certain service providers, we may use specific contracts approved by the UK government\r\n      which give personal data the same protection it has in the UK.</span></li>\r\n  <li aria-level=\"1\"><span>You have provided your explicit consent to the transfer of your personal data outside of the\r\n      UK.</span></li>\r\n  <li aria-level=\"1\"><span>The transfer is necessary for the purposes of performing a contract between us and you (the data\r\n      subject).</span></li>\r\n</ul>\r\n\r\n<ol class=\"title\" start=\"14\">\r\n  <li><b> Automated decision making and profiling</b></li>\r\n</ol>\r\n<p><span>We do not use automated decision-making (including profiling) to make any decisions which would produce a legal effect or similarly significantly\r\n    affect a data subject.</span></p>\r\n\r\n<ol class=\"title\" start=\"15\">\r\n  <li><b> How long do we retain your personal data?</b></li>\r\n</ol>\r\n<p><span>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of\r\n    satisfying any legal, accounting, or reporting requirements.</span></p>\r\n<p><span>To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the\r\n    potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes\r\n    through other means, and the applicable legal requirements.</span></p>\r\n<p><span>Personal data relating to Website users and business contacts will generally not be retained for longer than 12 months unless such data is\r\n    relevant to ongoing services. Personal data relating to individual customers and customer-related individuals will generally not be retained for longer than 7 years after\r\n    conclusion of the relevant services unless such data is relevant to any legal, accounting or reporting requirements. Please contact us at&nbsp;</span><a\r\n    href=\"mailto:info@xiasbio.com\"><span>info@xiasbio.com</span></a><span>&nbsp;for further details about our retention\r\n    periods.</span></p>\r\n\r\n<ol class=\"title\" start=\"16\">\r\n  <li><b> Data security</b></li>\r\n</ol>\r\n<p><span>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an\r\n    unauthorised way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business\r\n    need to know. They will only&nbsp;process your personal data on our instructions and they are subject to a duty of confidentiality.</span></p>\r\n<p><span>We have put in place procedures to deal with any suspected personal data breach and will notify you and the Information Commissioner’s\r\n    Office of a breach where we are legally required to do so.</span></p>\r\n\r\n<ol class=\"title\" start=\"17\">\r\n  <li><b> Your rights</b></li>\r\n</ol>\r\n<p><span>Your personal data is protected by legal rights, which include your rights to:&nbsp;</span></p>\r\n<ul>\r\n  <li aria-level=\"1\"><span>Request access to your personal data (commonly known as a “data subject access request”). This\r\n      enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.</span></li>\r\n  <li aria-level=\"1\"><span>Request correction of the personal data that we hold about you. This enables you to have any\r\n      incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us.</span></li>\r\n  <li aria-level=\"1\"><span>Request erasure of your personal data. This enables you to ask us to delete or remove personal data\r\n      where there is no good reason for us continuing to process it. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons\r\n      which will be notified to you, if applicable, following your request.</span></li>\r\n  <li aria-level=\"1\"><span>Object to processing of your personal data where we are relying on a legitimate interest (or those of\r\n      a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental\r\n      rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes.</span></li>\r\n  <li aria-level=\"1\"><span>Request restriction of processing of your personal data. This enables you to ask us to suspend the\r\n      processing of your personal data in the following scenarios: if you want us to establish the data’s accuracy; where our use of the data is unlawful but you do not want us to\r\n      erase it; where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or you have objected to our use of\r\n      your data but we need to verify whether we have overriding legitimate grounds to use it.</span></li>\r\n  <li aria-level=\"1\"><span>Request the transfer of your personal data to you or to a third party (data portability). We will\r\n      provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated\r\n      information which you initially provided consent for us to use or where we used the information to perform a contract with you.</span></li>\r\n  <li aria-level=\"1\"><span>Withdraw consent at any time where we are relying on consent to process your personal data. However,\r\n      this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain\r\n      services to you. We will advise you if this is the case at the time you withdraw your consent.</span></li>\r\n</ul>\r\n<p><span>If you wish to exercise any of these rights, please contact us at&nbsp;</span><a href=\"mailto:info@xiasbio.com\"><span>info@xiasbio.com</span></a></p>\r\n<p><span>We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to\r\n    exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact\r\n    you to ask you for further information in relation to your request to speed up our response.</span></p>\r\n<p><span>You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable\r\n    fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.</span></p>\r\n<p><span>We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly\r\n    complex or you have made a number of requests. In this case, we will notify you and keep you updated.</span></p>\r\n<p><span>You also have the right to complain to the Information Commissioner’s Office, which regulates the processing of personal data, about how we are\r\n    processing your personal data.</span></p>\r\n<p><br><br></p>",
                    "title": "Privacy Notice"
                },
                "name": "Legals",
                "type": "legals"
            }
        ]
    },
    "products": {
        "description": "Redefining high-performance proteins for innovative product development.",
        "name": "LiteProteins",
        "page_sections": [
            {
                "animation": "none",
                "flexible_height": true,
                "name": "LiteProteins™",
                "products_section": {
                    "details": "Redefining high-performance proteins for innovative product development. LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "display": "title",
                    "filter_options": [
                        {
                            "category": "haircare",
                            "name": "Haircare"
                        },
                        {
                            "category": "skincare",
                            "name": "Skincare"
                        }
                    ],
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "name": "Bespoke solutions",
                "type": "bespoke_solutions"
            }
        ]
    },
    "resilite": {
        "description": "Advanced Protein Innovation Inspired by Nature Advanced Protein Innovation Inspired by Nature ",
        "isProductPage": true,
        "name": "ResiLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Extraordinary elasticity",
                    "details_image": 2414,
                    "details_mobile": "Extraordinary elasticity",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "ResiLite™"
                        },
                        {
                            "text": "Advanced protein"
                        },
                        {
                            "text": "innovation inspired"
                        },
                        {
                            "text": "by nature"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "ResiLite™ is a groundbreaking...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "ResiLite™ is a groundbreaking protein innovation derived from Resilin, a naturally occurring protein in winged insects renowned for its extraordinary elasticity. Xias Bio has engineered Resilin-based peptides to unlock additional functionality, such as antioxidant properties, for transformative applications in hair care and skincare.\r\n<br/>\r\n<br/>\r\n<br/>\r\n<b/>Unmatched performance powered by the LiteProtein™ Platform</b>\r\n<br/>\r\n<br/>\r\nResiLite™ peptides are seamlessly integrated into our proprietary LiteProtein™ platform. This integration delivers a high concentration of Resilin functionality, enhancing product efficacy across a wide range of cosmetic and personal care applications.\r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2315,
                            "pointer": "none",
                            "position": "0.035,0.035,0.21,1"
                        },
                        {
                            "circle": true,
                            "image": 2283,
                            "pointer": "none",
                            "position": "0.33,0.58,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Physiological properties of ResiLite™...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.25",
                            "text": "<b>Film and barrier formation</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0,0.25,0.4",
                            "text": "<b>Hair protection</b>: <br/>Protects, smoothens, repairs, and enhances styling while boosting shine and strength"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.25,0.25,0.25",
                            "text": "<b>Water/oil-resistant films</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.6,0.25,0.2",
                            "text": "<b>Mild SPF-boosting properties</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.5,0.25,0.25",
                            "text": "<b>Hydrogel forming</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.75,0.25,0.25",
                            "text": "<b>Potent antioxidant</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Physiological properties of ResiLite™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Proven in vitro efficacy...",
                "product_details": {
                    "details": "Human dermal papilla cells",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0.1,0.25,0.5",
                            "text": "<b>Hair regeneration & healing</b>: <br/>Encourages follicular regrowth and resilience while balancing inflammation"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.36,0.25,0.5",
                            "text": "<b>Boosts vitality</b>: <br/>Activates hair growth markers for healthier, denser hair over time"
                        },
                        {
                            "pointer": "right",
                            "position": "0.08,0.92,0.25,0.25",
                            "text": "<b>Promotes follicular regrowth and resilience</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Proven <i>In Vitro</i> efficacy"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "The ResiLite™?",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Let’s talk",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Why ResiLite™?</div>\r\nThink of it as your go-to ingredient for smarter, more versatile formulas. ResiLite™ brings together advanced bioengineering and nature’s own resilience to power the next generation of skincare and haircare. Flexible, multifunctional, and built to perform – it’s a game-changer for formulators.\r\n<br/>\r\n<br/>\r\nCurious about the peptide version? \r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2441,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins™",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Let’s talk",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Why ResiLite™?</div>\r\nThink of it as your go-to ingredient for smarter, more versatile formulas. ResiLite™ brings together advanced bioengineering and nature’s own resilience to power the next generation of skincare and haircare. Flexible, multifunctional, and built to perform – it’s a game-changer for formulators.\r\n<br/>\r\n<br/>\r\nCurious about the peptide version? \r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2441,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Bespoke Solutions",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Let’s talk",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Why ResiLite™?</div>\r\nThink of it as your go-to ingredient for smarter, more versatile formulas. ResiLite™ brings together advanced bioengineering and nature’s own resilience to power the next generation of skincare and haircare. Flexible, multifunctional, and built to perform – it’s a game-changer for formulators.\r\n<br/>\r\n<br/>\r\nCurious about the peptide version? \r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2441,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "footer"
            }
        ],
        "snap": true
    },
    "sealite": {
        "description": "Revolutionising Sun Protection with Bio-Inspired Innovation",
        "isProductPage": true,
        "name": "SeaLite™",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Product Header",
                "story": {
                    "details": "Radiant defense",
                    "details_image": 2417,
                    "details_mobile": "Radiant defense",
                    "flexible_background_position": "0,0,1,0",
                    "story_lines": [
                        {
                            "large_text": true,
                            "text": "SeaLite™"
                        },
                        {
                            "text": "Revolutionizing sun"
                        },
                        {
                            "text": "protection with bio-"
                        },
                        {
                            "text": "inspired innovation"
                        }
                    ]
                },
                "type": "home_text"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "SeaLite™ is a pioneering...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "SeaLite™ is a pioneering protein ingredient addressing critical challenges in sun protection. As regulations increasingly phase out traditional SPF compounds due to their harmful impact on marine ecosystems, innovation is essential to ensure effective and environmentally safe sun care products.\r\n<br/><br/>\r\nDerived from UV-absorbing peptides found in sea cucumbers, SeaLite™ combines nature’s resilience with advanced biotechnology to deliver next-generation SPF-boosting solutions.\r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2419,
                            "pointer": "none",
                            "position": "0.035,0.035,0.21,1"
                        },
                        {
                            "circle": true,
                            "image": 2288,
                            "pointer": "none",
                            "position": "0.29,0.64,0.15,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "What sets SeaLite™ apart...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "none",
                            "position": "0,0,0.4,1",
                            "text": "SeaLite™ integrates UV-absorbing peptide sequences into the LiteProtein™ platform, creating a unique, multifunctional ingredient designed to enhance SPF performance while promoting skin health.\r\n<br/><br/>\r\nWith its ability to form water-resistant films and offer barrier protection, SeaLite™ supports hydration, repair, and rejuvenation – all critical factors for sensitive skin and high UV environments.\r\n\r\n",
                            "vertical_centered": true
                        }
                    ],
                    "flexible_background_position": "0.23,0,0.8,0",
                    "title": "What sets SeaLite™ apart?"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Key benefits of SeaLite...",
                "product_details": {
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0,0.25,0.3",
                            "text": "<b>SPF boosting</b>: <br/>UVA/UVB absorption enhances sun protection formulations."
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0,0.25,0.3",
                            "text": "<b>Antioxidant</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.8,0.25,0.2",
                            "text": "<b>Film & barrier forming</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.8,0.25,0.2",
                            "text": "<b>Biodegradable film formed by SeaLite™</b>"
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Key benefits of SeaLite™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "In vitro results",
                "product_details": {
                    "details": "SeaLite™ demonstrates impressive performance in lab tests",
                    "elements": [
                        {
                            "pointer": "right",
                            "position": "0,0.2,0.25,0.3",
                            "text": "<b>Skin barrier regeneration</b>"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0,0.25,0.3",
                            "text": "<b>Rejuvenation and renewal</b>"
                        },
                        {
                            "pointer": "right",
                            "position": "0,0.7,0.25,0.4",
                            "text": "<b>Enhanced hydration</b>: <br/>Boosts lipid synthesis and moisture retention"
                        },
                        {
                            "pointer": "left",
                            "position": "0.75,0.35,0.25,0.6",
                            "text": "<b>Protection against stress</b>: <br/>Ideal for sensitive skin and high UV exposure environments, reducing inflammation and oxidative damage."
                        }
                    ],
                    "flexible_background_position": "0,0,0.8,0",
                    "title": "Proven performance in 3D skin models (Mattek-EFT-400)"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Sustainable Protection, powered by Nature...",
                "product_details": {
                    "elements": [
                        {
                            "button": {
                                "title": "Explore SeaLite™",
                                "url": "/licensing/"
                            },
                            "pointer": "none",
                            "position": "0.59,0,0.4,1",
                            "text": "<div className=\"title\">Sustainable protection, powered by nature</div>\r\nSeaLite™ isn’t just another ingredient – it’s the future of sun care. Designed for high performance and sustainability, it helps brands create SPF products that protect skin and the planet. Safe, effective, and eco-friendly – because great sun care shouldn’t come at a cost to the environment.\r\n",
                            "vertical_centered": true
                        },
                        {
                            "circle": true,
                            "image": 2427,
                            "pointer": "none",
                            "position": "0.20,0.12,0.33.5,1"
                        }
                    ],
                    "flexible_background_position": "-0.23,0,0.8,0"
                },
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "product_details"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "LiteProteins",
                "products_section": {
                    "details": "LiteProteins™ are smart, multifunctional proteins designed to spark innovation and give your products a real edge - whatever your industry.",
                    "details_button": {
                        "title": "Start innovating",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "products_tile_view"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Bespoke Solutions",
                "products_section": {
                    "details": "LiteProteins™ are advanced, patentable, multi-functional proteins engineered to drive innovation and deliver a competitive edge across industries.",
                    "details_button": {
                        "title": "Learn more",
                        "url": "/products/"
                    },
                    "display": "in_page",
                    "title": "LiteProteins™"
                },
                "type": "bespoke_solutions"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Whatever stage you're at, our approach is flexible, cost-efficient, and aligned with your goals. Let us help you bring your vision to life with a solution tailored just for you.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "type": "footer"
            }
        ],
        "snap": true
    },
    "sectors": {
        "description": "At Xias Bio, we are dedicated to collaborating with scientists across diverse sectors to create sustainable, scalable protein solutions.",
        "name": "Sectors",
        "page_sections": [
            {
                "about_header": {
                    "elements": [
                        {
                            "depth": 3.6,
                            "image": 903,
                            "position": "0,0.12,0.23,0.9",
                            "position_mobile": "0,0.14,0.25,1.2",
                            "priority": true,
                            "type": "image"
                        },
                        {
                            "depth": 1,
                            "image": 2594,
                            "position": "0.2,0.02,0.35,1",
                            "priority": true,
                            "type": "image"
                        },
                        {
                            "depth": 2,
                            "image": 901,
                            "position": "0.5,0.12,0.24,1",
                            "position_mobile": "0.5,0.16,0.25,1.3",
                            "priority": true,
                            "type": "image"
                        },
                        {
                            "depth": 0,
                            "image": 2600,
                            "position": "0.77,0.04,0.2,1",
                            "position_mobile": "0.7,0.04,0.25,1",
                            "priority": true,
                            "type": "image"
                        },
                        {
                            "depth": 2,
                            "hide_on_mobiles": true,
                            "image": 3047,
                            "position": "0,0.52,0.4,0.9",
                            "position_mobile": "0,0.52,0.4,1.3",
                            "type": "image"
                        },
                        {
                            "depth": 0.4,
                            "group_on_mobiles": "group-1",
                            "position": "0.5,0.6,0.42,1",
                            "position_mobile": "0,0.57,1,1",
                            "text": "By leveraging our breakthrough protein design LitePlatform™, we offer the opportunity to transform complex challenges into actionable, high-performance solutions across diverse sectors. ",
                            "type": "text"
                        },
                        {
                            "depth": 0.8,
                            "group_on_mobiles": "group-1",
                            "position": "0.2,0.99,0.56,1",
                            "position_mobile": "0,1.07,0.76,1",
                            "text": "Our versatile proteins and peptides can be tailored to meet specific needs within each industry, offering a customisable foundation for advancing innovation and solving critical problems.",
                            "type": "text"
                        }
                    ],
                    "full_width_title": true,
                    "height_multiplier": 1.36,
                    "height_multiplier_mobile": 2,
                    "title": "Unlock sustainable, scalable solutions across multiple industries"
                },
                "animation": "none",
                "home_page_sectors": {
                    "images": [
                        {
                            "depth": 5,
                            "image": 903,
                            "position": "0,0.4,0.23,1"
                        },
                        {
                            "depth": 1,
                            "image": 904,
                            "position": "0.2,0.2,0.35,1"
                        },
                        {
                            "depth": 3,
                            "image": 901,
                            "position": "0.5,0.6,0.24,1"
                        },
                        {
                            "image": 902,
                            "link": "/sectors/",
                            "position": "0.77,0.39,0.2,1"
                        }
                    ],
                    "title": "Unlock sustainable, scalable solutions across multiple industries with Xias Bio"
                },
                "name": "Sectors Header",
                "type": "about_header"
            },
            {
                "accordion": {
                    "accordion": [
                        {
                            "column": [
                                {
                                    "details": "Shifting consumer preferences toward clean, ethical, and sustainable beauty products are driving the industry away from animal-based ingredients.\r\n<br/>\r\n<br/>\r\nPlant-based and synthetic alternatives have been introduced, but often face limitations in performance, cost, scalability, and potential allergenicity.\r\n<br/>\r\n<br/>\r\nEnvironmental and regulatory challenges, around petrochemical-derived ingredients are accelerating the need for innovative, sustainable ingredient solutions.",
                                    "title": "Challenges"
                                },
                                {
                                    "details": "LitePlatform™ allows the creation of multifunctional, high-performance proteins that replace animal-derived ingredients with sustainable, biotech-driven alternatives. Whether its microbiome-focused, barrier strengthening, anti-aging, or hair care and styling ingredients, our customisable proteins provide scalable solutions without compromising efficacy or ethics.",
                                    "title": "How Xias Bio helps"
                                },
                                {
                                    "details": "Creating an anti-aging serum? Our proteins can be tailored to boost collagen production, support skin regeneration, and provide antioxidant protection while being fully biodegradable and ethically sourced.",
                                    "title": "Example"
                                }
                            ],
                            "title": "Personal Care"
                        },
                        {
                            "column": [
                                {
                                    "details": "Growing demand for sustainable agricultural practices.\r\n<br/>\r\n<br/>\r\nNeed for sustainable, alternative proteins and functional peptides to improve crop yields, pest resistance, and plant health.",
                                    "title": "Challenges"
                                },
                                {
                                    "details": "We provide a sustainable source of proteins that can be engineered for agricultural applications. From enhancing soil health to protecting your seeds from diseases, our proteins offer scalable solutions to meet industry challenges.",
                                    "title": "How Xias Bio helps"
                                },
                                {
                                    "details": "Developing a biodegradable seed dressing? Our platform can create proteins that protect seeds and incubate inoculants and biostimulants that deliver increased crop yields.",
                                    "title": "Example"
                                }
                            ],
                            "title": "Agtech"
                        }
                    ],
                    "title": "Explore how we can help you in the following sectors:"
                },
                "animation": "none",
                "flexible_height": true,
                "footer": {
                    "details": "Contact Xias Bio today to discuss how we can help solve your most pressing challenges with scalable, sustainable solutions."
                },
                "name": "Sectors Accordion",
                "type": "accordion"
            },
            {
                "animation": "none",
                "flexible_height": true,
                "name": "Sectors Cards",
                "sectors_cards": {
                    "cards": [
                        {
                            "details": "We focus on providing sustainable, ethical protein and peptide solutions that help industries reduce their environmental footprint.",
                            "image": 942,
                            "title": "Sustainability"
                        },
                        {
                            "details": "Our platform is designed to scale with your needs, from lab testing to full-scale commercial production.",
                            "image": 941,
                            "title": "Scalability"
                        },
                        {
                            "details": "Whether you're in personal care, AgTech or food, we provide highly customisable protein and peptide solutions tailored to your specific needs.",
                            "image": 940,
                            "title": "Customization"
                        }
                    ],
                    "title": "Why choose Xias Bio?"
                },
                "type": "sectors_cards"
            },
            {
                "animation": "none",
                "connect": {
                    "details": "Contact Xias Bio today to discuss how we can help make your next generation innovative products.",
                    "display": "in_page",
                    "title": "Ready to transform your industry with breakthrough protein technology?"
                },
                "name": "Connect",
                "type": "connect"
            }
        ]
    },
    "solutions": {
        "description": "Tailored solutions that bring your product vision to life",
        "name": "Solutions",
        "page_sections": [
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Header 1",
                "solutions_header": {
                    "details": "At Xias Bio, your vision deserves a partner who can turn ideas into impactful, market-ready solutions.",
                    "logo_background_anim": "logo_reveal",
                    "title": "Bring your vision to life with tailored, sustainable solutions."
                },
                "type": "solutions_header"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Header 2",
                "solutions_header": {
                    "details": "Our LiteProtein™ platform molecule features flexible slots, allowing you to seamlessly integrate the protein needed to achieve your desired functionality.",
                    "logo_background_anim": "points_intro"
                },
                "type": "solutions_header"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Header 3",
                "solutions_header": {
                    "details": "This building-block approach to protein design enables us to craft proteins with unparalleled precision and adaptability, tailored to meet your unique market requirements.",
                    "logo_background_anim": "points_outro"
                },
                "type": "solutions_header"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Content 1",
                "solutions_content": {
                    "elements": [
                        {
                            "depth": 2,
                            "image": 862,
                            "position": "0,0.23,0.39,0.9",
                            "position_mobile": "-0.1,0,0.78,0.8",
                            "type": "image"
                        },
                        {
                            "depth": 4,
                            "image": 860,
                            "position": "0.26,0.5,0.2,0.9",
                            "position_mobile": "0.55,0.06,0.35,0.9",
                            "type": "image"
                        },
                        {
                            "depth": 1,
                            "position": "0.58,0.27,0.4,1",
                            "position_mobile": "0.,0.42,1,1",
                            "text": "<span class=\"title\">\r\nDiscovery service\r\n</span>\r\n<br/><br/>\r\nOur discovery service finds and characterizes new active peptides and proteins to match your performance and product needs.",
                            "type": "text"
                        }
                    ]
                },
                "type": "solutions_content"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Content 2",
                "solutions_content": {
                    "elements": [
                        {
                            "depth": 1,
                            "position": "0,0.2,0.36,1",
                            "position_mobile": "0,0.42,1,1",
                            "text": "Customers can use discovery services to\r\n<br/>\r\n<br/>\r\n– Interrogate the vast protein space to identify new potent actives using bioinformatics\r\n<br/>\r\n<br/>\r\n– Identify new actives from crude extract and hydrolysate sources using Xias Bio’s proprietary performance screening test panel.",
                            "type": "text"
                        },
                        {
                            "depth": 5,
                            "image": 858,
                            "position": "0.525,0.53,0.19,1.7",
                            "position_mobile": "0.095,0.06,0.49,0.8",
                            "type": "image"
                        },
                        {
                            "depth": 3,
                            "image": 861,
                            "position": "0.67,0.18,0.3,1.7",
                            "position_mobile": "0.49,-0.04,0.5,1.4",
                            "type": "image"
                        }
                    ]
                },
                "type": "solutions_content"
            },
            {
                "animation": "none",
                "force_snap": true,
                "name": "Solutions Content 3",
                "solutions_content": {
                    "elements": [
                        {
                            "depth": 1,
                            "position": "0,0.263,0.45,1",
                            "position_mobile": "0,0.4,1,1",
                            "text": "<span class=\"title\">\r\nUnlock the potential\r\n</span>\r\n<br/><br/>\r\nXias Bio is committed to helping you take your product development to the next level. Whether you’re looking to enhance product efficacy, meet cost targets, or adapt to the latest consumer trends, our LitePlatform™ ensures your solution is both innovative and market-ready. ",
                            "type": "text"
                        },
                        {
                            "depth": 2,
                            "image": 3049,
                            "position": "0.55,0.23,0.45,0.9",
                            "position_mobile": "0.33,-0.03,0.78,0.9",
                            "type": "image"
                        }
                    ]
                },
                "type": "solutions_content"
            },
            {
                "animation": "none",
                "footer": {
                    "details": "Ready to create something extraordinary? Let us help you develop bespoke, scalable, and high-performance protein solutions. Contact us today to learn more about how we can collaborate and accelerate your next project.",
                    "display": "in_page"
                },
                "force_snap": true,
                "name": "Footer",
                "type": "footer"
            }
        ],
        "snap": true
    },
    "terms-conditions": {
        "description": "Terms & Conditions",
        "name": "Terms & Conditions",
        "page_sections": [
            {
                "animation": "none",
                "flexible_height": true,
                "legals": {
                    "content": "<p class=\"title\"><b>Information about us</b></p>\r\n<p><span>These Terms and Conditions govern use of this website [https://www.xiasbio.com] (“</span><b>Website</b><span>“),\r\n\t\tincluding all webpages under that domain and all local versions of the Website.</span></p>\r\n<p><span>This Website is owned and operated by Xias Bio Ltd., a company incorporated and registered in Scotland under the Companies Acts (no. SC657022)\r\n\t\tand having its registered office at E116, Xias Bio Ltd, UWS Paisley Campus, Lady Lane, Paisley, Scotland, PA1 2BE, (“Us/We/Our”)</span></p>\r\n<p><span>By visiting this Website you agree to be bound by the following terms and conditions.</span></p>\r\n<p><span>We understand the importance of maintaining your privacy and ensuring we treat your personal information carefully and in confidence. Please\r\n\t\trefer to our Privacy Policy&nbsp;for further details of how we use your personal details (both in relation to personal information that you choose to share with us or upload to\r\n\t\tthe Website, as well as personal information which may be collected automatically, for instance by cookies and related technologies) .</span></p>\r\n<p class=\"title\"><b>Use of the site</b></p>\r\n<p><span>This Website may only be used for lawful purposes and in a lawful manner in order to obtain information about Our company and our products and\r\n\t\tservices. You must not use this Website in a way which restricts or inhibits the use or enjoyment of the Website by any third party or which infringes the rights of any third\r\n\t\tparty. You agree to comply with all applicable laws, statutes and regulations regarding this Website and its use. You agree not to upload or transmit through the Website: any\r\n\t\tcomputer viruses or anything else designed to undermine the security of this Website or otherwise interfere with, interrupt or disrupt the normal operating procedures of a\r\n\t\tcomputer; and any material which is defamatory, offensive or of an obscene character, or which infringes our intellectual property rights, or those of a third party.</span></p>\r\n<p><span>You must not corrupt the Website, flood the Website with information so as to cause the Website not to function or use any features which may\r\n\t\taffect the function of the Website, for example viruses, worms, logic bombs, denial of service attacks or similar. You must not interfere with, remove or otherwise alter in any\r\n\t\tway, any information which is included on the Website.</span></p>\r\n<p><span>You can ask for content to be removed from the Website, but we will only consider removal in limited circumstances, for example where content may\r\n\t\tbreach intellectual property laws, contains sensitive personal data or material that may be considered obscene or defamatory, and will do so at our sole discretion.</span></p>\r\n<p class=\"title\"><b>User account</b></p>\r\n<p><span>You may have the opportunity to create a user account to access some parts of the Website and to obtain user only content. These same Terms and\r\n\t\tConditions apply to any user only parts of the Website.</span></p>\r\n<p><span>We will take all reasonable precautions to ensure the secure storage of your account information, including your username and password. However,\r\n\t\tyou must not disclose your password or username to any other person, and should choose a password of sufficient length and complexity which cannot easily be guessed.</span></p>\r\n<p class=\"title\"><b>Copyright</b></p>\r\n<p><span>Copyright in the content of and the publications in this website is owned by Us or its licensors.</span></p>\r\n<p><span>You may download and temporarily store one or more of the pages of this website for the purposes of viewing them. You may also print any of the\r\n\t\tpublications in this website so long as each copy is a complete copy, no amendment is made to it and it is for your use or only within your organisation.</span></p>\r\n<p><span>Any other storage, copying, transmission or distribution of the content of or the publications in this website is prohibited without Our prior\r\n\t\twritten consent. Please address requests to your usual contact at Xias Bio who will direct your enquiry appropriately or send a request to&nbsp;</span><a\r\n\t\thref=\"mailto:info@xiasbio.com\"><span>info@xiasbio.com</span></a><span>.</span></p>\r\n<p><span>Xias Bio’s logo, and any other trademarks which appear on this Website are owned by Xias Bio Ltd. or other third party owners and used by Us\r\n\t\tunder licence. Any unauthorised use of the trademarks is prohibited. Access to this site does not imply or grant any right to use Xias Bio’s trademarks or registered trademarks\r\n\t\tand no licenses or right to use are granted by implication or otherwise in respect of any copyrights, patents, trademarks in relation to this website.</span></p>\r\n<p class=\"title\"><b>Our liability</b></p>\r\n<p><span>The material available on this site is provided on an “as is” basis for general information only. It is believed to be accurate and is given in\r\n\t\tgood faith but no representation or warranty as to its completeness or accuracy is made. Neither Xias Bio Ltd nor any other Xias Bio entity accepts any responsibility for any\r\n\t\tloss which may arise from reliance on information or materials published on this website. If you wish to find out more about the information in the materials published, please\r\n\t\tget in touch with your usual contact at Xias Bio or send a request to&nbsp;</span><a href=\"mailto:info@xiasbio.com\"><span\r\n\t\t\tstyle=\"font-weight: 400;\">info@xiasbio.com</span></a><span>.</span></p>\r\n<p><span>To the extent permitted by law, We hereby expressly exclude:</span></p>\r\n<p><span>All conditions, warranties and other terms which might otherwise be implied by statute, common law or the law of equity.</span></p>\r\n<p><span>Any liability for any direct, indirect or consequential loss or damage incurred by any user in connection with our site or in connection with the\r\n\t\tuse, inability to use, or results of the use of our site, any websites linked to it and any materials posted on it, including, without limitation any liability for:</span></p>\r\n<ul>\r\n\t<li aria-level=\"1\"><span>loss of income or revenue;</span></li>\r\n\t<li aria-level=\"1\"><span>loss of business;</span></li>\r\n\t<li aria-level=\"1\"><span>loss of profits or contracts;</span></li>\r\n\t<li aria-level=\"1\"><span>loss of anticipated savings;</span></li>\r\n\t<li aria-level=\"1\"><span>loss of data;</span></li>\r\n\t<li aria-level=\"1\"><span>loss of goodwill;</span></li>\r\n</ul>\r\n<p><span>and for any other loss or damage of any kind, however arising and whether caused by tort (including negligence), breach of contract or otherwise,\r\n\t\teven if foreseeable, and including in each case costs or associated legal fees.</span></p>\r\n<p><span>This does not affect our liability for death or personal injury arising from our negligence, nor our liability for fraudulent misrepresentation\r\n\t\tor misrepresentation as to a fundamental matter, nor any other liability which cannot be excluded or limited under applicable law.</span></p>\r\n<p class=\"title\"><b>Links</b></p>\r\n<p><span>Any links to other websites or content are provided for convenience only. We do not endorse or take responsibility for third party sites or\r\n\t\tcontent, and because of the nature of the internet and the risks of interruption and disruption, any and all liability which might arise from your use or reliance on the\r\n\t\tinformation or links contained on the website is excluded.</span></p>\r\n<p class=\"title\"><b>Website availability</b></p>\r\n<p><span>We may discontinue access to this Website, and/or any services provided on this Website, at our sole discretion, at any time, without\r\n\t\tnotice.</span></p>\r\n<p class=\"title\"><b>Changes to this policy</b></p>\r\n<p><span>The Internet is constantly developing. As such we reserve the right to update this policy at any time. Please regularly review this page to\r\n\t\tensure you are aware of any changes that we make.</span></p>\r\n<p class=\"title\"><b>Contact</b></p>\r\n<p><span>If you have any questions, comments or requests regarding the material which appears on Our website, please write or email us at the following\r\n\t\taddress:</span></p>\r\n<p><span>Website Enquiries</span><span><br></span></span><a href=\"mailto:info@xiasbio.com\"><span\r\n\t\t\tstyle=\"font-weight: 400;\">info@xiasbio.com</span></a></p>\r\n\r\n<p><span>E116, Xias Bio Ltd,&nbsp;</span></p>\r\n<p><span>UWS Paisley Campus, Lady Lane,&nbsp;</span></p>\r\n<p><span>Paisley, Scotland, PA1 2BE</span><span><br>\r\n\r\n<p class=\"title\"><b>General provisions</b></p>\r\n<p><span>These Terms and Conditions of use and all issues regarding the website are governed by and construed in accordance with the law of England and\r\n\t\tWales.</span></p>\r\n<p><span>To the extent that any provision of these Terms and Conditions is unlawful, void or unenforceable, it shall be severed without affecting the\r\n\t\tvalidity and enforceability of any remaining provisions.</span></p>\r\n<p><span>Any failure by Us to act with respect to any breach of these Terms and Conditions shall not constitute a waiver of Our right to act with respect\r\n\t\tto future or similar breaches</span></p>",
                    "title": "Terms & Conditions"
                },
                "name": "Legals",
                "type": "legals"
            }
        ]
    }
};
